import { render, staticRenderFns } from "./InfiniteScrolling.vue?vue&type=template&id=65560af5"
import script from "./InfiniteScrolling.vue?vue&type=script&lang=js"
export * from "./InfiniteScrolling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports